package com.anjuros.website.templates.template4.modules


import com.anjuros.website.templates.template4.util.ResKey
import com.anjuros.website.templates.template4.util.Template4Res

enum class Template4Project (
    val image:String,
    val projectName:ResKey,
    val description:ResKey,
    val gallery : List<String>
){

    Project1(Template4Res.Image.template4_project1, ResKey.TEMPLATE4_PROJECT1_TITLE,
        description = ResKey.TEMPLATE4_PROJECT1_DESC,
        listOf(
        Template4Res.Image.template4_project1_gallery1,
        Template4Res.Image.template4_project1_gallery2,
        Template4Res.Image.template4_project1_gallery3,
        Template4Res.Image.template4_project1_gallery4,
        Template4Res.Image.template4_project1_gallery5

    )),
    Project2(Template4Res.Image.template4_project2, ResKey.TEMPLATE4_PROJECT2_TITLE,
        description = ResKey.TEMPLATE4_PROJECT2_DESC,
        listOf(
        Template4Res.Image.template4_project2_gallery1,
        Template4Res.Image.template4_project2_gallery2,
        Template4Res.Image.template4_project2_gallery3,
        Template4Res.Image.template4_project2_gallery4,
        Template4Res.Image.template4_project2_gallery5,
        Template4Res.Image.template4_project2_gallery6

    )),
    Project3(Template4Res.Image.template4_project3, ResKey.TEMPLATE4_PROJECT3_TITLE,
        description = ResKey.TEMPLATE4_PROJECT3_DESC,

        listOf(
        Template4Res.Image.template4_project3_gallery1,
        Template4Res.Image.template4_project3_gallery2,
        Template4Res.Image.template4_project3_gallery3,
        Template4Res.Image.template4_project3_gallery4,
        Template4Res.Image.template4_project3_gallery5,
        Template4Res.Image.template4_project3_gallery6,

    ))
}




